import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

const Buscador = ({ dataBusqueda, dataPagina, filtroValue, filtros }) => {

    filtroValue = (filtroValue) ? filtroValue : ""

    const [busqueda, setBusqueda] = useState(dataBusqueda)
    const [filtro, setFiltro] = useState(filtroValue)

    useEffect(() => {
        setBusqueda(dataBusqueda)
        setFiltro(filtroValue)
    }, [dataBusqueda, filtroValue])

    let history = useNavigate()

    const handleSearch = () => {
        if (dataBusqueda != busqueda || filtroValue != filtro) {
            history(`/${dataPagina}?bus=${busqueda}&pag=1&fil=${filtro}`)
        }
        return false
    }

    const forceHandleSearch = (val) => {
        history(`/${dataPagina}?bus=${busqueda}&pag=1&fil=${val}`)
    }
    return (

        <form onSubmit={e => { e.preventDefault(); handleSearch() }} name="buscador">

            <div className="row">
                <div className="col-10">
                    <div className="row">
                        <div className="col">
                            <input className="form-control" type="search" placeholder="Buscar..." value={busqueda} onChange={e => { setBusqueda(e.target.value) }} name="buscador"/>
                        </div>
                        {
                            (filtros) && (
                                <div className="col-4">
                                    <select className="form-control" onChange={e => { forceHandleSearch(e.target.value) }} value={filtro}>
                                        {
                                            filtros.map((filtro) => {
                                                return (
                                                    <option key={filtro.value} value={filtro.value} >{filtro.texto}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className="col-2">
                    <button type="submit" className="btn btn-danger btn-block"><i className="fas fa-search"></i></button>
                </div>
            </div>

        </form>

    )
}
export default Buscador